<div class="mat-elevation-z5">
  @if (data.title) {
    <mat-toolbar color="primary">
      <mat-icon svgIcon="{{data.icon}}"></mat-icon>
      <h1 class="mat-title">{{data.title}}</h1>
    </mat-toolbar>
  }
  <div class="mat-body">
    {{data.message}}
  </div>
  <div class="uf-action-row">
    <button mat-button mat-raised-button class="mat-primary" (click)="onOk()">Ok</button>
  </div>
</div>
